export default "__VITE_ASSET__a811cb79__"